// src/admindashboardutils/components/AverageCallTime.jsx
import React from "react";

const AverageCallTime = ({ averageCallTime }) => (
  <div className="bg-white rounded-lg p-4 shadow-md flex-1 flex flex-col justify-center items-center">
    <h3 className="text-lg font-medium text-gray-700 mb-4">Average Call Time (Today)</h3>
    <div className="flex justify-center items-center">
      <span className="text-3xl font-bold text-gray-800">{averageCallTime}</span>
      <span className="text-lg text-gray-600 ml-2">seconds</span>
    </div>
  </div>
);

export default AverageCallTime;